<template>
<div class="container">

      <div class="e2018_map_widget">

        <div class="title">Election 2020 Results</div>

        <ul class="nav">
            <li :class="{ 'active' : current_page == 'president' }" @click="set_current_page('president')">President</li>
            <li :class="{ 'active' : current_page == 'senate' }" @click="set_current_page('senate')">Senate</li>
            <li :class="{ 'active' : current_page == 'house' }" @click="set_current_page('house')">House</li>
            <!--<li :class="{ 'active' : current_page == 'governor' }" @click="set_current_page('governor')">Governor</li>-->
        </ul>

        <div class="pages">
            <div class="page president" v-if="current_page == 'president'">
          
                <div v-if="loading" class="e2018_spinner">
                    <div>
                        <div></div>
                    </div>
                </div>
  
            <div class="score" v-if="current_page == 'president'">
                <div v-show="first_load_done" class="party dem">
                    <span class="score"><a :href="`${E2020_PUB_PATH}/president/`" v-html="electoral_summary.Biden"></a></span>
                    <span class="title"><a :href="`${E2020_PUB_PATH}/president/`">Biden/Harris</a></span>
                </div>
            <div v-show="first_load_done" class="party gop">
                <span class="title"><a :href="`${E2020_PUB_PATH}/president/`">Trump/Pence</a></span>
                <span class="score"><a :href="`${E2020_PUB_PATH}/president/`" v-html="electoral_summary.Trump"></a></span>
            </div>
            </div>
            <div class="score" v-if="current_page !== 'president'">
                <div v-show="first_load_done" class="party dem">
                    <span class="score"><a :href="`${E2020_PUB_PATH}/president/`" v-html="won_seats.president.dem + '' + net_display(net_seats.president.dem)"></a></span>
                    <span class="title"><a :href="`${E2020_PUB_PATH}/president/`">Democrats</a></span>
                </div>
                <div v-show="first_load_done" class="party gop">
                    <span class="title">
                        <a :href="`${E2020_PUB_PATH}/president/`">Republicans</a>
                    </span>
                    <span class="score">
                        <a :href="`${E2020_PUB_PATH}/president/`" v-html="won_seats.president.gop + '' + net_display(net_seats.president.gop)"></a>
                    </span>
                </div>
            </div>
  
            <div class="map">
                <a :href="E2020_PUB_PATH+'/president/'">
                    <transition name="fade">
                        <img :key="img_map['president']" :src="img_map['president']" alt="President Live Results 2020" />
                    </transition>
                </a>
            </div>
  
        </div>

            <div class="page senate" v-if="current_page == 'senate'">
            
                <div v-if="loading" class="e2018_spinner">
                    <div>
                        <div></div>
                    </div>
                </div>

                <div class="score">
                    <div v-show="first_load_done" class="party dem">
                        <span class="score">
                            <a :href="E2020_PUB_PATH+'/senate/'" v-html="won_seats.senate.dem + '*' + net_display(net_seats.senate.dem)"></a>
                        </span>
                        <span class="title">
                            <a :href="E2020_PUB_PATH+'/senate/'">Democrats</a>
                        </span>
                    </div>
                    <div v-show="first_load_done" class="party gop">
                        <span class="title">
                            <a :href="E2020_PUB_PATH+'/senate/'">Republicans</a>
                        </span>
                        <span class="score">
                            <a :href="E2020_PUB_PATH+'/senate/'" v-html="won_seats.senate.gop + '' + net_display(net_seats.senate.gop)"></a>
                        </span>
                    </div>
                </div>

                <div class="map">
                    <a :href="E2020_PUB_PATH+'/senate/'">
                        <transition name="fade">
                            <img :key="img_map['senate']" :src="img_map['senate']" alt="Senate Live Results 2020" />
                        </transition>
                    </a>
                </div>

          </div>

          <div class="page house" v-if="current_page == 'house'">
            
                <div v-if="loading" class="e2018_spinner">
                    <div>
                        <div></div>
                    </div>
                </div>

                <div class="score">
                    <div v-show="first_load_done" class="party dem">
                        <span class="score">
                            <a :href="E2020_PUB_PATH+'/house/'" v-html="won_seats.house.dem + '' + net_display(net_seats.house.dem)"></a>
                        </span>
                        <span class="title">
                            <a :href="E2020_PUB_PATH+'/house/'">Democrats</a>
                        </span>
                    </div>
                    <div v-show="first_load_done" class="party gop">
                        <span class="title">
                            <a :href="E2020_PUB_PATH+'/house/'">Republicans</a>
                        </span>
                        <span class="score">
                            <a :href="E2020_PUB_PATH+'/house/'" v-html="won_seats.house.gop + '' + net_display(net_seats.house.gop)"></a>
                        </span>
                    </div>
                </div>

                <div class="map">
                    <a :href="E2020_PUB_PATH+'/house/'">
                        <transition name="fade">
                            <img :key="img_map['house']" :src="img_map['house']" alt="House Live Results 2020" />
                        </transition>
                    </a>
                </div>

            </div>

            <!--<div class="page governor" v-if="current_page == 'governor'">
            
                    <div v-if="loading" class="e2018_spinner">
                        <div>
                            <div></div>
                        </div>
                    </div>

                    <div class="score">
                        <div v-show="first_load_done" class="party dem">
                            <span class="score">
                                <a :href="E2020_PUB_PATH+'/governor/'" v-html="won_seats.governor.dem + '' + net_display(net_seats.governor.dem)"></a>
                            </span>
                            <span class="title">
                                <a :href="E2020_PUB_PATH+'/governor/'">Democrats</a>
                            </span>
                    </div>
                    <div v-show="first_load_done" class="party gop">
                        <span class="title">
                            <a :href="E2020_PUB_PATH+'/governor/'">Republicans</a>
                        </span>
                        <span class="score">
                            <a :href="E2020_PUB_PATH+'/governor/'" v-html="won_seats.governor.gop + '' + net_display(net_seats.governor.gop)"></a>
                        </span>
                    </div>
                </div>

                <div class="map">
                    <a :href="E2020_PUB_PATH+'/governor/'">
                        <transition name="fade">
                            <img :key="img_map['governor']" :src="img_map['governor']" alt="Governor Live Results 2018" />
                        </transition>
                    </a>
                </div>

            </div>-->

        </div>
    </div>
</div>
</template>

<script>

import {rcp_refresh_interval, E2020_PUB_PATH} from './ElectionCommonVars.js';
import ElectionNightMixin from './ElectionNightMixin.js';

export default {
    name: 'rc-widget-live-results-beta-1',
    mixins: [
        ElectionNightMixin,
    ],
    data : function() {
        return {
            "loading_interval" : 0,
            "loading" : true,
            "first_load_done" : false,
            "current_page" : "president",
            "pages" : ["president","senate","house"],
            "seconds_per_tab" : 15,
            "tab_interval": 0,
            "img_map" : {
                "president" : "",
                "senate" : "",
                "house" : "",
                "governor" : ""
            },
            "president_summary" : {},
            "electoral_summary" : {
                "Biden" : 0,
                "Trump" : 0,
            },
            "won_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            },
            "net_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            }
        };
    },
    created : function() {

        this.get_data_for_beta_1();

        // Start refresh cron
        this.loading_interval = setInterval(() => {
            this.fetch_data();
        }, rcp_refresh_interval * 1000);

        // Start timer for switching tab
        this.tab_interval = setInterval(() => {

            var tab_index = this.pages.indexOf(this.current_page);
            tab_index += 1;
            if(tab_index > this.pages.length - 1) {
                tab_index = 0;
            }
            this.current_page = this.pages[tab_index];

        }, this.seconds_per_tab * 1000);
    },
    methods: {

        set_current_page : function(pagename) {
            this.current_page = pagename;
            clearInterval(this.tab_interval);
        },

        fetch_data : function() {

            if(!this.loading) {
                this.get_data_for_beta_1();
            }
        },

        get_data_for_beta_1 : function() {

            this.loading = true;
            // Retrieve live results data
            this.rcp_hp_fetch_data((response) => {

                // Successfully retrieved data

                this.won_seats = response.data.won_seats;
                this.net_seats = response.data.net_seats;
                this.president_summary = response.data.president_summary;
                this.electoral_summary = response.data.electoral_summary;

                // Refresh images
                var types = ['president','senate','house','governor'];
                for(var i = 0; i < types.length; i++) {
                    if(this.current_page == types[i]) {
                        // Do smart loading
                        var img = new Image();
                        var vue_this = this;
                        var src = E2020_PUB_PATH+"/live_map_"+types[i]+"_thumb.png?cache_bust="+this.rcp_cache_bust();
                        var callback_apply = function(callback, vue_this, types, i, src) {
                            callback(vue_this, types, i, src);
                        }

                        img.onload = callback_apply(function(vue_this, types, i, src) {
                            vue_this.img_map[types[i]] = src;
                            vue_this.loading = false;
                        }, vue_this, types, i, src);

                        img.src = src;
                    } else {
                        // Just change src... that way images in pages not loaded won't load... reducing http requests
                        this.img_map[types[i]] = E2020_PUB_PATH+"/live_map_"+types[i]+"_thumb.png?cache_bust="+this.rcp_cache_bust();
                    }
                }

                this.first_load_done = true;

            });
        },

  },
}
</script>

<style lang="scss">

</style>